class PfStrengthBox extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const variants = Array.from(this.querySelectorAll(".Selectbox"));
        if (!variants.length) return;

        const PVA = document.querySelector("pf-product-variants-and-atc");
        if (PVA && window.innerWidth < 768) return;

        const selectedVariant = this.querySelector(`.Selectbox[data-is-selected="true"][data-is-available="true"]`);
        const bestSaleVariant = this.querySelector(`.Selectbox[data-is-available="true"]:has(input[value="+2.0"])`);

        // Priority 1 — Explicitly preselected variant (metafield)
        if (this.clickVariant(selectedVariant)) return;

        // Priority 2 — Best sale variant (+2.0)
        if (this.clickVariant(bestSaleVariant)) return;

        // Priority 3 — First available variant
        const firstAvailable = variants.find(v => v.getAttribute("data-is-available") === "true");
        this.clickVariant(firstAvailable);
    }

    get productEl() {
      return document.querySelector("product-component");
    }

    clickVariant(variant) {
      if (!variant) return false;

      replaceStickyButtonListener();

      const label = variant.querySelector("label");
      if (label) {
          label.click();

          // const shouldReload = this.dataset.sellingPlans != 0 && !this.dataset.selectedVariant && this.productEl.dataset.noReload != "true" && this.dataset.productId == this.productEl.dataset.productId
          const shouldReload = this.dataset.sellingPlans != 0 && !this.dataset.selectedVariant && this.dataset.productId == this.productEl.dataset.productId

          if(shouldReload) {
            window.location.reload();
          } else {
            // this.productEl.dataset.noReload = "true";
          }

          return true;
      }
      return false;
    }
}

// Register custom element once
if (!customElements.get("pf-strength-box")) {
    customElements.define("pf-strength-box", PfStrengthBox);
}


/* -------------------------
   Scroll Listener Handling
------------------------- */

let scrollListenerAttached = false;

document.addEventListener("DOMContentLoaded", initScrollListener);
document.addEventListener("shopify:section:load", initScrollListener);

function initScrollListener() {
  if (scrollListenerAttached) return;

  const target = window;
  target.addEventListener('scroll', onScroll, { passive: true });
  target.addEventListener('touchmove', onScroll, { passive: true });

  scrollListenerAttached = true;
}

function onScroll() { 
  checkATCVisibility();
}


/* -------------------------
   Sticky ATC Visibility
------------------------- */

function checkATCVisibility() {
  const target = document.querySelector(".pm__atc-button");
  const target2 = document.querySelector("variant-selectbox");
  const stickyBar = document.querySelector(".pm__buttons-pay-quantity .pm__sticky-atc");
  if (!target || !target2 || !stickyBar) return;

  const rect = target.getBoundingClientRect();
  const rect2 = target2.getBoundingClientRect();
  // const isOutOfView = rect.top >= window.innerHeight || rect.bottom <= 0;
  const isOutOfView = rect.bottom <= 0 && rect2.bottom <= 0;

  if (isOutOfView) {
    stickyBar.classList.add("open");
    stickyBar.removeAttribute("aria-hidden");

    stickyBar.querySelectorAll("*").forEach(elm => elm.removeAttribute("aria-hidden"));

    replaceStickyButtonListener();
  } else {
    stickyBar.classList.remove("open");
    stickyBar.setAttribute("aria-hidden", "true");
  }
}


/* -------------------------
   Sticky Button Listener
------------------------- */

function replaceStickyButtonListener() {
    const stickyBtn = document.querySelector(".pf-sticky-atc");
    const productBtn = document.querySelector(".pm__product-atc-wrapper button");
    if (!stickyBtn || !productBtn) return;

    const stickyButtonListener = () => {
        const PVA = document.querySelector("pf-product-variants-and-atc");
        const modal = PVA?.querySelector(".strength_modal_wrapper");
        const isVariant = PVA?.getAttribute('data-is-variant') === "false";

        if (PVA && window.innerWidth < 768 && isVariant){
          modal?.classList.add("active");
          window.scrollTo({
            top: 400,
            behavior: 'smooth'
          });
        } else{
          productBtn.click();
        }
    };

    stickyBtn.replaceWith(stickyBtn.cloneNode(true));
    const newStickyBtn = document.querySelector(".pf-sticky-atc");
    newStickyBtn.addEventListener("click", stickyButtonListener);
}

class PfProductV extends HTMLElement {
  constructor() {
    super();

    // Bind functions so "this" stays correct
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.outsideClickClose = this.outsideClickClose.bind(this);
  }

  connectedCallback() {
    this.chooseBtn = this.querySelector(".choose_strength_btn");
    this.modal = this.querySelector(".strength_modal_wrapper");
    this.closeBtn = this.querySelector(".close_btn");
    this.mainContent = this.querySelector(".main_content");
    this.atcBtn = this.querySelector(".atc_redirect_btn");
    const items = this.querySelectorAll(".pf_option");

    this.chooseBtn?.addEventListener("click", this.openModal);
    this.closeBtn?.addEventListener("click", this.closeModal);
    this.atcBtn?.addEventListener("click",() => {
        this.handleAtc();
    });


    // Close when clicking outside modal content
    this.modal?.addEventListener("click", this.outsideClickClose);

    items?.forEach((item)=>{
        item.addEventListener("click", (e)=>{
            this.itemClick(e, item);
        });
    })
  }

  get sellingPlans() {
    return parseInt(document.querySelector("pf-strength-box")?.dataset.sellingPlans || 0);
  }

  get tryonBtnExists() {
    return !!document.querySelector(".pm__product-atc-wrapper tryon-button");
  }

  openModal() {
    this.modal?.classList.add("active");
  }

  closeModal() {
    this.modal?.classList.remove("active");
  }

  outsideClickClose(event) {
    // If clicking outside `.main_content`, close modal
    if (!this.mainContent.contains(event.target)) {
      this.closeModal();
    }
  }

  itemClick(e,item){
    const value = item.getAttribute("data-value");
    const isAvailable = item.getAttribute("data-available");
    const strength = document.querySelector(`pf-strength-box .Selectbox:has(input[value="${value}"]) label`);
    this.setAttribute('data-is-variant', true);

    strength?.click();

    const isButton = e.target.closest(".option_atc_btn");
    if (isButton && (this.sellingPlans == 0 || !this.tryonBtnExists)) {
      setTimeout(() => {
        const productBtn = document.querySelector(".pm__product-atc-wrapper button");
        if (productBtn && document.body.contains(productBtn)) {
          productBtn.click();
        } else {
          console.warn("Button not connected to DOM yet");
        }
      }, 1000);
    }

    const atcButton = this.querySelector(".atc_redirect_btn");
    const chooseBtn = this.querySelector(".choose_strength_btn .text");
    chooseBtn.innerHTML = value;

    // atcButton.querySelectorAll("span").forEach(elm=>elm.innerHTML = atcButton.getAttribute("data-atc-text"));

    if(isAvailable === "false"){
      atcButton.querySelectorAll("span").forEach(elm=>elm.innerHTML = atcButton.getAttribute("data-ntf-text"));
    } else {
      atcButton.querySelectorAll("span").forEach(elm=>elm.innerHTML = atcButton.getAttribute("data-atc-text"));
    }

    this.closeModal();
  }

  handleAtc(){
    const isVariant = this.closest("pf-product-variants-and-atc").getAttribute('data-is-variant') === "true";
    const productBtn = document.querySelector(".pm__product-atc-wrapper button");

    if(isVariant){
        productBtn?.click();
    } else {
        this.openModal();
    }
  }
}

// Register custom element once
if (!customElements.get("pf-product-variants-and-atc")) {
  customElements.define("pf-product-variants-and-atc", PfProductV);
}
